import { computed } from 'vue';
import { toValue } from '@vueuse/core';

import { useUpc } from '@modules/upc';

import { useProductType } from '@composables/useProductType';
import useMembersOfProduct from '@composables/useMembersOfProduct';

/**
 * @param {string} productId
 *
 * @returns {{
 *  selectedTrueFitProductId: import('vue').ComputedRef<string>,
 *  trueFitProductIds: string[],
 * }}
 */
export function useLoadedTrueFitProduct(productId) {
  const { isConsolidatedPage } = useProductType();
  const { memberProductsMap } = useMembersOfProduct();
  const unRefMemberProductsMap = toValue(memberProductsMap);
  const memberProductIds = Object.keys(unRefMemberProductsMap);
  const { upcData, selectedUpcId } = useUpc();
  /**
   * @param {string} id
   * @returns {boolean}
   */
  const findMemberProduct = (id) => unRefMemberProductsMap?.[id]?.detail?.flags?.truefitEligible;
  const trueFitProductIds = isConsolidatedPage ? memberProductIds.filter(findMemberProduct) : [productId];
  const selectedProductId = computed(
    () => (selectedUpcId.value && isConsolidatedPage
      ? upcData.value.upcs[selectedUpcId.value]?.relationships?.selectedProduct
      : trueFitProductIds[0]),
  );
  const selectedTrueFitProductId = computed(() => {
    if (trueFitProductIds.includes(selectedProductId.value)) {
      return selectedProductId.value;
    }

    return trueFitProductIds.find(findMemberProduct);
  });

  return {
    selectedTrueFitProductId,
    trueFitProductIds,
  };
}

export default useLoadedTrueFitProduct;
